interface IConditionalWrapperProps {
  condition: boolean;
  wrapper: (children: React.ReactNode) => React.ReactNode;
  children: React.ReactNode;
}

const ConditionalWrapper = ({
  condition,
  wrapper,
  children
}: IConditionalWrapperProps) =>
  condition ? wrapper(children) : <>{children}</>;

export default ConditionalWrapper;
